import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appName]'
})
export class NameDirective {


  // Letras mayúsculas con acentos y punto
  private regex: RegExp = /^[A-ZÁÉÍÓÚÑÜ. ]$/;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(): void {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value.toUpperCase();
    let filteredValue = '';
    let lastChar = '';

    for (let i = 0; i < value.length; i++) {
      const char = value[i];

      if (!this.regex.test(char)) {
        continue;
      }

      // No permitir punto al inicio
      if (i === 0 && char === '.') {
        continue;
      }

      // No permitir puntos seguidos
      if (char === '.' && lastChar === '.') {
        continue;
      }

      // No permitir espacio al inicio
      if (i === 0 && char === ' ') {
        continue;
      }

      // No permitir espacios seguidos
      if (char === ' ' && lastChar === ' ') {
        continue;
      }

      filteredValue += char;
      lastChar = char;
    }

    if (filteredValue !== input.value) {
      input.value = filteredValue;
      input.dispatchEvent(new Event('input'));
    }
  }
}
